import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { HttpBadStatusCodeError } from '@cian/peperrors';

import { ISyncChat1 } from '../../repositories/newbuilding-consultants/entities/sync_chat1/SyncChat1';
import {
  fetchGetOrCreateChat,
  TGetOrCreateChatResponse,
} from '../../repositories/newbuilding-consultants/v1/get-or-create-chat';
import { TSourcePage } from '../../repositories/newbuilding-consultants/entities/get_or_create_chat/PublicV1GetOrCreateChatRequest';

interface IConsultantChatProps {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: {
    pageUrl?: string;
    sourcePage: TSourcePage;
  };
}

export const fetchConsultantCianChat = async ({
  httpApi,
  logger,
  parameters,
}: IConsultantChatProps): Promise<ISyncChat1 | null> => {
  try {
    const data: TGetOrCreateChatResponse = await fetchGetOrCreateChat({
      httpApi,
      parameters,
    });

    if (data.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: data.statusCode,
        domain: 'resolveConsultantChat',
        message: data.response.message as string,
      });
    }

    return data.response.chat || null;
  } catch (error) {
    logger.error(error, {
      domain: 'fetchConsultantCianChat',
    });

    return null;
  }
};
